module.exports = __webpack_public_path__ + "static/media/logo_new.1a76fa2f.png";